// À La Carte Order Redux Constants

export const SET_ALACARTE_STEP = 'SET_ALACARTE_STEP';
export const SET_BOX_COUNT = 'SET_BOX_COUNT';
export const SET_BOX_PRODUCT = 'SET_BOX_PRODUCT';
export const SET_PACKING_SUPPLIES = 'SET_PACKING_SUPPLIES';
export const SET_MOVING_SUPPLIES = 'SET_MOVING_SUPPLIES';
export const ADD_PACKING_SUPPLY = 'ADD_PACKING_SUPPLY';
export const REMOVE_PACKING_SUPPLY = 'REMOVE_PACKING_SUPPLY';
export const UPDATE_PACKING_SUPPLY_QUANTITY = 'UPDATE_PACKING_SUPPLY_QUANTITY';
export const ADD_MOVING_SUPPLY = 'ADD_MOVING_SUPPLY';
export const REMOVE_MOVING_SUPPLY = 'REMOVE_MOVING_SUPPLY';
export const UPDATE_MOVING_SUPPLY_QUANTITY = 'UPDATE_MOVING_SUPPLY_QUANTITY';
export const SET_DELIVERY_DETAILS = 'SET_DELIVERY_DETAILS';
export const SET_PICKUP_DETAILS = 'SET_PICKUP_DETAILS';
export const SET_CUSTOMER_INFO = 'SET_CUSTOMER_INFO';
export const SET_RENTAL_INFO = 'SET_RENTAL_INFO';
export const SET_LOCKED_PICKUP_DETAILS = 'SET_LOCKED_PICKUP_DETAILS';
export const SET_DELIVERY_ADDRESS_FROM_RENTAL = 'SET_DELIVERY_ADDRESS_FROM_RENTAL';
export const SET_TAX_RATE = 'SET_TAX_RATE';
export const SET_EXTRA_WORK = 'SET_EXTRA_WORK';
export const SET_DELIVERY_EXTRA_WORK = 'SET_DELIVERY_EXTRA_WORK';
export const SET_PICKUP_EXTRA_WORK = 'SET_PICKUP_EXTRA_WORK';
export const SET_ORDER_ID = 'SET_ORDER_ID';
export const CALCULATE_TOTAL = 'CALCULATE_TOTAL';
export const RESET_ALACARTE_STORE = 'RESET_ALACARTE_STORE';
